var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-coupon"},[_c('Swipe'),_c('Guide'),_c('Coupons'),_c('Coupons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }